import { JSX } from 'react';
import classNames from 'classnames';
import { GamificationIconType } from './enums';
import { IGamificationIcon } from './interfaces';
import classes from './GamificationIcon.module.scss';

interface IProps extends IGamificationIcon {
    icon: GamificationIconType;
}

export const GamificationIcon = (props: IProps): JSX.Element => (
    <i className={classNames(classes.icon, classes[props.icon], props.className)} />
);
